//#region IMPORT
import React, { useEffect, useMemo } from 'react';
import { Dialog } from '../MUIs';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { getColumnDefs, getColumnDefsForAccidentStatus } from './MemberInfoModal_ColumnDefs';
import useMemberInfoModal from './useMemberInfoModal';
//#endregion

function MemberInfoModal({ open, onClose, onSelection, columnVariant, multiYn }) {
  // useMemberInfoModal 훅 사용
  const memberInfoModal = useMemberInfoModal({ onSelection, multiYn });

  const { modal, grid, handlers } = memberInfoModal;

  const columnDefs = useMemo(() => {
    const base =
      columnVariant === 'accidentStatus'
        ? getColumnDefsForAccidentStatus()
        : getColumnDefs();
    if (!multiYn === 'Y') return base;
    return [
      {
        headerName: '',
        colId: '__memberInfo_checkbox',
        width: 52,
        maxWidth: 52,
        checkboxSelection: true,
        headerCheckboxSelection: true,
        sortable: false,
        filter: false,
        floatingFilter: false,
        suppressMovable: true,
      },
      ...base,
    ];
  }, [columnVariant, multiYn]);

  // 모달이 열릴 때 자동으로 조회
  useEffect(() => {
    if (open) {
      modal.onOpen();
    }
  }, [open]);

  // 모달 닫기 핸들러
  const handleClose = () => {
    modal.onClose();
    if (onClose) {
      onClose();
    }
  };

  return (
    <>
      {/* 회원정보 팝업 창 */}
      {open && (
        <div
          role="presentation"
          className="MuiDialog-root MuiModal-root"
          inert="true"
        >
          <Dialog
            title={'회원정보'}
            open={open}
            onClose={handleClose}
            contentSx={{ display: 'flex', flexDirection: 'column' }}
            fullWidth
            saveButtonName={'선택'}
            closeButtonName={'닫기'}
            useSaveButton={true}
            useSaveAfterClose={true}
            maxWidth="xl"
            onSave={() => {
              handlers.onSelection();
            }}
            content={
              <div
                className="ag-theme-alpine no-scroll"
                style={{ height: '600px', width: '100%' }}
              >
                <AgGridReact
                  ref={grid.ref}
                  animationRows={true}
                  columnDefs={columnDefs}
                  rowData={grid.rowData}
                  defaultColDef={{
                    minWidth: 100,
                    editable: false,
                    resizable: true,
                    sortable: true,
                    filter: true,
                    floatingFilter: true,
                  }}
                  rowSelection={multiYn === 'Y' ? 'multiple' : 'single'}
                  rowMultiSelectWithClick={multiYn === 'Y'}
                  onSelectionChanged={() => {
                    GridFunctions.onSelectionChanged(grid.ref, (_selected) => {
                      grid.setSelectedRowData(_selected);
                    });
                  }}
                  getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                  enableBrowserTooltips={true}
                  tooltipShowDelay={0}
                  onRowDoubleClicked={(e) => {
                    handlers.onDoubleClick?.(e.data);
                    handleClose();
                  }}
                />
              </div>
            }
          />
        </div>
      )}
    </>
  );
}

export default MemberInfoModal;
